module.exports = __webpack_public_path__ + "media/images/responsive/page_common/noimage/square/text_gray01-6c720d1297ba608df8882f8e6fd87027.png";